import { useEffect } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';

export function useTrackPageView(): void {
	const track = useTracking();

	useEffect(() => {
		void track('sponsor_view');
		// only send the view event once per page load
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
}
